import { Component, OnInit } from '@angular/core';
interface WindowStatus {
  [key: string]: number;
}
interface MachineStatus {
  topic: string;
  data: WindowStatus;
}

@Component({
  selector: 'app-annunciator',
  templateUrl: './annunciator.component.html',
  styleUrls: ['./annunciator.component.scss']
})
export class AnnunciatorComponent implements OnInit {

  private ws: WebSocket;
  isData = false;
  public machines: { [key: string]: MachineStatus } = {};
  public windowNames: { [key: string]: { [key: string]: string } } = {};
  public editingWindow: string | null = null;
  ngOnInit() {
 

    this.ws = new WebSocket('wss://api.trafobola.com');
    this.ws.onopen = () => {
      console.log(':link: WebSocket connected to Node.js');
    };
    this.ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      this.isData = true;
      const machineId = message.topic.split('/')[1];
      const windowData = JSON.parse(message.data);
      delete windowData.slave_id;
      delete windowData.status;
      const sortedWindowData: WindowStatus = {};
      Object.keys(windowData)
        .sort((a, b) => {
          const numA = parseInt(a.replace('window', ''));
          const numB = parseInt(b.replace('window', ''));
          return numA - numB;
        })
        .forEach(key => {
          sortedWindowData[key] = windowData[key];
        });
      this.machines[machineId] = {
        topic: message.topic,
        data: sortedWindowData
      };
      if (!this.windowNames[machineId]) {
        this.windowNames[machineId] = {};
        Object.keys(sortedWindowData).forEach(windowKey => {
          this.windowNames[machineId][windowKey] = windowKey;
        });
      }
    };
    this.ws.onerror = (error) => {
      console.error('WebSocket Error:', error);
    };
    this.ws.onclose = () => {
      console.log('WebSocket disconnected');
    };
  }
  startEditing(machineId: string, windowKey: string) {
    this.editingWindow = windowKey;
  }
  updateWindowName(machineId: string, windowKey: string, newName: string) {
    if (this.windowNames[machineId]) {
      this.windowNames[machineId][windowKey] = newName;
      this.editingWindow = null;
    }
  }

}
